import React, { memo } from 'react'
import { TableLabel } from 'src/components/shared/label/TableLabel'
import { TableLabels } from 'src/components/shared/label/TableLabels'
import { Market } from 'src/interfaces/market'
import { useFormatMarketsData } from 'src/utils/hooks/useFormatMarketsData'

interface Props {
  markets: (Market | string)[] | null
  isAllMarkets: boolean
}

const TableMarketLabelsComponent = ({ markets, isAllMarkets }: Props) => {
  const getParsedMarketsTitles = useFormatMarketsData()

  const marketTitles = getParsedMarketsTitles(markets)

  if (isAllMarkets) {
    return <TableLabel label="All markets" />
  }

  if (!marketTitles.length) {
    return <span>-</span>
  }

  return <TableLabels labels={marketTitles} moreLabel="Market" />
}

export const TableMarketLabels = memo(TableMarketLabelsComponent)
